<footer class="footer">
  <div class="content has-text-centered">
    <p class="text-center">
      © Copyright 2022 Auxo Ads. All Rights Reserved.
    </p>
  </div>
</footer>

